<template>
  <section-page
    title="Next Contact At"
    description="These are the default Next Contact At task settings that will be used when its been created. You will be able to override them by updating the created task."
  >
    <grid-row class="my-100 px-75">
      <form-field-switch
        class="mb-25"
        label="Creates Task"
        v-model="form.is_next_contact_at"
        size=""
        help-text='If off no "Next Contact At" task will be created'
      />
    </grid-row>

    <grid-row class="my-100 px-75">
      <form-field-select-users
        label="Assigned To"
        v-model="form.next_contact_at_user_id"
        :selectable-users="users"
        has-empty-option
        help-text="If None is selected, task will be assigned to whoever is currently working on the lead"
      />
    </grid-row>

    <div class="flex flex-end save-btn-container">
      <button-outlined
        @click="save"
        :loading="saving"
      >Save Settings
      </button-outlined>
    </div>
  </section-page>
</template>

<script>
import api from "../../../api";

export default {
  name: "TaskNextContactAt",
  data() {
    return {
      saving: false,
      form: {
        is_next_contact_at: true,
        next_contact_at_user_id: null
      },
    }
  },
  mounted() {
    this.form = {
      is_next_contact_at: this.account.is_next_contact_at,
      next_contact_at_user_id: this.account.next_contact_at_user_id,
    };
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    users() {
      return this.$store.getters.activeUsers;
    },
  },
  methods: {
    save() {
      this.saving = true
      api.accounts.updateTaskSettings(this.account.id, this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Your 'Next Contact At' settings have been saved",
            type: "is-success"
          });
        })
        .finally(() => this.saving = false)
    }
  }
}
</script>

<style scoped lang="scss">
.save-btn-container {
  margin-right: -.75em;
}
</style>
